import {
    DASHBOARD_PANEL_SHARE_OPEN_MODAL,
    DASHBOARD_PANEL_SHARE_REQUEST,
    DASHBOARD_PANEL_SHARE_RESULT,
    DASHBOARD_PANEL_GET_DASHBOARD_REQUEST,
    DASHBOARD_PANEL_GET_DASHBOARD_RESULT,
    
} from 'Redux/actionTypes'

export const dashboardPanelShareOpenModal = (open, data) => ({
    type: DASHBOARD_PANEL_SHARE_OPEN_MODAL,
    payload: { open, data }
})

export const dashboardPanelShareRequest = (data) => ({
    type: DASHBOARD_PANEL_SHARE_REQUEST,
    payload: data
})

export const dashboardPanelShareResult = (data) => ({
    type: DASHBOARD_PANEL_SHARE_RESULT,
    payload: data
})

export const dashboardPanelGetDashboardRequest = (id) => ({
    type: DASHBOARD_PANEL_GET_DASHBOARD_REQUEST,
    payload: { id }
})

export const dashboardPanelGetDashboardResult = (data) => ({
    type: DASHBOARD_PANEL_GET_DASHBOARD_RESULT,
    payload: data
})

